// ensure the main object is defined
if (typeof (so) === 'undefined') {
    var so = {
        app: {
            flipster: {}
        }
    };
}

// main code
so.app.flipster = {
    init: function () {
        var flipster = $('.coverflow').flipster({
            itemContainer: '.cover-flow-container',
            itemSelector: '.cover-item',
            style: 'flat',
            spacing: 1,
            start: 0,
            keyboard: true,
            buttons: false,
            scrollwheel: false,
            touch: true,
            onItemSwitch: so.app.flipster.itemSwitchHandler
        });

        var prev = $('.page-control').on('click', function () {
            var target = $(this).data('target');
            var direction = $(this).data('direction');
            $('#'+target).flipster(direction);
        });

        // setTimeout(so.app.flipster.setupSlider, 10);


        // $('.magflix-modal').on('show.bs.modal', function (event) {
        //     let youtubelink;
        //     var slide = $(event.relatedTarget); // Button that triggered the modal
        //     var youtubeid = slide.data('youtubeid'); // Extract info from data-* attributes
        //     var title = slide.data('title'); // Extract info from data-* attributes
        //     var modal = $(this);
        //     modal.find('.modal-title').text(title);
        //     youtubelink = 'https://www.youtube-nocookie.com/embed/' + youtubeid;
        //     modal.find('.flipster-iframe').attr('src', youtubelink);
        // }).on('hide.bs.modal', function (event) {
        //     var modal = $(this);
        //     modal.find('.flipster-iframe').attr('src', ""); //stop playing by removing the src
        // });
    },
    itemSwitchHandler: function (currentItem, previousItem, slide_index) {

        var items = $(this).find('.flipster__container').children();
        var last_slide = items.length - 1;
        if (slide_index === 0) {
            $(this).parents('section').find('.cover-flow-position-meter').removeClass('end').removeClass("start").removeClass("middle").addClass('start');
        } else if (slide_index === last_slide) {
            $(this).parents('section').find('.cover-flow-position-meter').removeClass('end').removeClass("start").removeClass("middle").addClass("end");
        } else {
            $(this).parents('section').find('.cover-flow-position-meter').removeClass('end').removeClass("start").removeClass("middle").addClass("middle");
        }
    },
    getMatrixValues: function (element) {
        const style = window.getComputedStyle(element)
        const matrix = style['transform'] || style.webkitTransform || style.mozTransform

        // No transform property. Simply return 0 values.
        if (matrix === 'none' || typeof matrix === 'undefined') {
            return {
                x: 0,
                y: 0,
                z: 0
            }
        }

        // Can either be 2d or 3d transform
        const matrixType = matrix.includes('3d') ? '3d' : '2d'
        const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

        // 2d matrices have 6 values
        // Last 2 values are X and Y.
        // 2d matrices does not have Z value.
        if (matrixType === '2d') {
            return {
                x: parseInt(matrixValues[4]),
                y: parseInt(matrixValues[5]),
                z: parseInt(0)
            }
        }

        // 3d matrices have 16 values
        // The 13th, 14th, and 15th values are X, Y, and Z
        if (matrixType === '3d') {
            return {
                x: parseInt(matrixValues[12]),
                y: parseInt(matrixValues[13]),
                z: parseInt(matrixValues[14])
            }
        }

    },
    getElementOffset: function (el) {
        let top = 0;
        let left = 0;
        let element = el;

        // Loop through the DOM tree
        // and add it's parent's offset to get page offset
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);

        return {
            top,
            left,
        };
    },
    calculateCorrection: function () {
        var correction, newLeftOffset;
        const {x, y, z} = so.app.flipster.getMatrixValues(document.getElementsByClassName('flipster__container')[0]);
        var leftOffset = so.app.flipster.getElementOffset(document.getElementById('cover-flow-position-meter')).left;

        correction = x - leftOffset;
        newLeftOffset = x - correction;
        return newLeftOffset;
    },
    setupSlider: function () {
        var correction;
        if (!$('.flipster__container').length > 0) {
            setTimeout(so.app.flipster.setupSlider, 10);
            return false;
        }
        correction = so.app.flipster.calculateCorrection();
        document.getElementsByClassName('flipster__container')[0].style.transform = 'translateX('+correction+'px)';


    },
    itemSwitch: function (one, two) {
        var correction = so.app.flipster.calculateCorrection();
        document.getElementsByClassName('flipster__container')[0].style.transform = 'translateX(' + correction + 'px)';
    }
};

window.onload = function () {
    so.app.flipster.init();
};
